// extracted by mini-css-extract-plugin
module.exports = {"keyVisualSearch":"SkeletonTopSearchInput_keyVisualSearch__lQhYl","list":"SkeletonTopSearchInput_list__Jp7yh","btn":"SkeletonTopSearchInput_btn__Jz5Jd"};